const canonicalQuery = (params) => {
    const entries = [];

    params.forEach((value, key) => {
        if (key === "page" || value === "") {
            return;
        }

        entries.push([key.replace(/\[\d*\]$/, "[]"), value]);
    });

    entries.sort(([leftKey, leftValue], [rightKey, rightValue]) => {
        if (leftKey === rightKey) {
            return leftValue.localeCompare(rightValue);
        }

        return leftKey.localeCompare(rightKey);
    });

    const next = new URLSearchParams();

    entries.forEach(([key, value]) => {
        next.append(key, value);
    });

    return next.toString();
};

const serializeForm = (form) => {
    const params = new URLSearchParams();

    new FormData(form).forEach((value, key) => {
        if (typeof value !== "string") {
            return;
        }

        const trimmed = value.trim();

        if (trimmed === "") {
            return;
        }

        params.append(key, trimmed);
    });

    return canonicalQuery(params);
};

const currentFilterQuery = () => canonicalQuery(new URLSearchParams(window.location.search));

export const registerImmediateFilterForm = (Alpine) => {
    Alpine.data(
        "immediateFilterForm",
        ({ debounceMs = 350, searchName = "search", selectNames = ["status"] } = {}) => ({
            debounceTimer: null,
            searchName,
            selectNames,

            onInput(event) {
                if (
                    !(event.target instanceof HTMLInputElement) ||
                    event.target.name !== this.searchName
                ) {
                    return;
                }

                this.submitSoon();
            },

            onChange(event) {
                if (
                    !(event.target instanceof HTMLSelectElement) ||
                    event.target.multiple ||
                    !this.selectNames.includes(event.target.name)
                ) {
                    return;
                }

                this.submitNow();
            },

            onFilterSelectClosed(event) {
                const name = event.detail?.name;

                if (typeof name !== "string" || !this.selectNames.includes(name)) {
                    return;
                }

                this.submitNow();
            },

            submitSoon() {
                window.clearTimeout(this.debounceTimer);
                this.debounceTimer = window.setTimeout(() => {
                    this.submitIfChanged();
                }, debounceMs);
            },

            submitNow() {
                window.clearTimeout(this.debounceTimer);
                this.submitIfChanged();
            },

            submitIfChanged() {
                if (!(this.$el instanceof HTMLFormElement)) {
                    return;
                }

                if (serializeForm(this.$el) === currentFilterQuery()) {
                    return;
                }

                this.$el.requestSubmit();
            },
        }),
    );
};
